import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
	orders: [],
	loading: false,
	error: null,
	purchased: false,
};

const purchasingInit = (state, action) => {
	return updateObject(state, { purchased: false });
};

const purchasingStarted = (state, action) => {
	return updateObject(state, { loading: true });
};

const purchaseBurgerSuccess = (state, action) => {
	const createdOrder = { ...action.orderData };
	return updateObject(state, {
		orders: state.orders.concat(createdOrder),
		loading: false,
		purchased: true,
	});
};

const purchaseBurgerError = (state, action) => {
	return updateObject(state, { loading: false });
};

const fetchOrdersStart = (state, action) => {
	return updateObject(state, { loading: true });
};

const fetchOrdersSuccess = (state, action) => {
	return updateObject(state, { orders: action.orders, loading: false });
};

const fetchOrdersError = (state, action) => {
	return updateObject(state, { loading: false });
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.PURCHASING_INIT:
			return purchasingInit(state, action);

		case actionTypes.PURCHASING_STARTED:
			return purchasingStarted(state, action);

		case actionTypes.PURCHASE_BURGER_SUCCESS:
			return purchaseBurgerSuccess(state, action);

		case actionTypes.PURCHASE_BURGER_ERROR:
			return purchaseBurgerError(state, action);

		case actionTypes.FETCH_ORDERS_START:
			return fetchOrdersStart(state, action);

		case actionTypes.FETCH_ORDERS_SUCCESS:
			return fetchOrdersSuccess(state, action);

		case actionTypes.FETCH_ORDERS_ERROR:
			return fetchOrdersError(state, action);
		default:
			return state;
	}
};

export default reducer;
